import { useCallback } from 'react';

import { replaceTextAlignAttribute } from './replace-text-align-attribute';

import './render-quill-content.css';
import { TextAlignmentsEnum } from '@/types/template-layouts.types';

interface IRenderQuillContentProps {
  descriptionOverrides?: string;
  description: string;
  defaultTextAlignment?: TextAlignmentsEnum;
  stopPropagation?: boolean;
  className?: string;
  bypassIfNodeElement?: boolean;
}

const RenderQuillContent: React.FC<IRenderQuillContentProps> = ({
  description,
  defaultTextAlignment = TextAlignmentsEnum.left,
  stopPropagation,
  className = '',
  /*
    Note: set bypassIfNodeElement to true to prevent overriding text alignment of existing html elements.
    We only want to change the alignment when switching module layouts that require changes, not when rendering content.
  */
  bypassIfNodeElement = true,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  // if content is straight text (not html), we need to wrap it in html and give it the appropriate text alignment
  const convertToHtml = useCallback(() => {
    return replaceTextAlignAttribute({ htmlString: description, newValue: defaultTextAlignment, bypassIfNodeElement });
  }, [description, defaultTextAlignment, bypassIfNodeElement]);

  return (
    <div className="quill-content">
      <div
        className={className || ''}
        dangerouslySetInnerHTML={{ __html: convertToHtml() }}
        // stopPropagation may not work with conditionals inside the callback, only as a conditional around the entire function
        onClick={stopPropagation ? undefined : handleClick}
      />
    </div>
  );
};

export default RenderQuillContent;
